(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    /* Sticky add-to-cart button: spinner while adding, checkmark on success.

     Two things make this trickier than it looks:

     1. The sticky button forwards its click to the real product form button,
        so the success signal (data-added) lands on that element, not this one.
        We watch the document for it instead.

     2. When the cart updates, the theme morphs the sticky bar's CHILDREN -
        the button element is replaced, so any attribute set on it is wiped
        almost immediately. The state therefore lives on the outer
        <sticky-add-to-cart> element, which survives the morph.

     MIN_SPIN gives the spinner a floor so it stays visible even when the add
     resolves instantly. It only ever extends a fast add, never delays a slow one. */
  if (!window.__amuzeStickyAtcState) {
    window.__amuzeStickyAtcState = true;

    var AMUZE_MIN_SPIN = 600;
    var AMUZE_HOLD_CHECK = 1500;

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var button = target.closest('.sticky-add-to-cart__button');
        if (!button || button.disabled) return;

        var host = button.closest('sticky-add-to-cart');
        if (!host || host.getAttribute('data-state')) return;

        var started = Date.now();
        host.setAttribute('data-state', 'loading');

        var settle = function (state) {
          observer.disconnect();
          clearTimeout(failsafe);

          var remaining = Math.max(0, AMUZE_MIN_SPIN - (Date.now() - started));

          setTimeout(function () {
            if (state === 'done') {
              host.setAttribute('data-state', 'done');
              setTimeout(function () {
                host.removeAttribute('data-state');
              }, AMUZE_HOLD_CHECK);
            } else {
              host.removeAttribute('data-state');
            }
          }, remaining);
        };

        var observer = new MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            var el = records[i].target;
            if (el.getAttribute && el.getAttribute('data-added') === 'true') {
              settle('done');
              return;
            }
          }
        });

        observer.observe(document.body, {
          subtree: true,
          attributes: true,
          attributeFilter: ['data-added']
        });

        /* If the add never reports success, drop back to the idle icon
           rather than leaving a spinner running forever. */
        var failsafe = setTimeout(function () {
          settle('idle');
        }, 4000);
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["card-sizes"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('card-sizes')) return;

    /* Keeps only the sizes that fit whole on the one line, and adds the
       ellipsis when any are left out (by the "Maximum sizes shown" setting
       or by the width). Re-run when a card changes width and when the web
       fonts arrive.

       Performance (05/10/2026): the first version measured each card on its
       own, showing every size, reading the widths and hiding them again,
       card after card. Each of those reads forced the browser to restyle and
       lay out the whole page, and the home page has 60+ cards: on a mid-range
       phone that was about 14 seconds of frozen page after load (55s with
       Lighthouse's 4x CPU slowdown). Now:
       - one ResizeObserver for all the cards, so the browser hands them over
         in one batch;
       - every batch does all its writes, then all its reads (one layout for
         the whole batch), then all its writes;
       - the widths of the sizes are measured once (and again when the fonts
         arrive) and kept, so a resize only reads the card's width;
       - a size is only shown or hidden when its state actually changes. */
    const pending = new Set();
    let frame = 0;

    const run = () => {
      if (frame) {
        cancelAnimationFrame(frame);
        frame = 0;
      }
      const cards = [...pending].filter((card) => card.isConnected);
      pending.clear();
      if (!cards.length) return;

      for (const card of cards) if (!card.widths) card.showAll();
      for (const card of cards) card.read();
      for (const card of cards) card.apply();
    };

    const later = (card) => {
      pending.add(card);
      if (!frame) frame = requestAnimationFrame(run);
    };

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) pending.add(entry.target);
      run();
    });

    document.fonts?.ready.then(() => {
      for (const card of document.querySelectorAll('card-sizes')) {
        card.widths = null;
        later(card);
      }
    });

    class CardSizes extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.card-sizes__item:not(.card-sizes__item--more)')];
        this.more = this.querySelector('.card-sizes__item--more');
        this.widths = null;
        if (this.items.length) observer.observe(this);
      }

      disconnectedCallback() {
        observer.unobserve(this);
        pending.delete(this);
      }

      showAll() {
        for (const item of this.items) if (item.hidden) item.hidden = false;
        if (this.more && this.more.hidden) this.more.hidden = false;
      }

      read() {
        const cs = getComputedStyle(this);
        this.avail = this.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        this.gap = parseFloat(cs.columnGap) || 0;
        if (!this.widths && this.avail > 0) {
          this.widths = this.items.map((item) => item.getBoundingClientRect().width);
          this.moreWidth = this.more ? this.more.getBoundingClientRect().width : 0;
        }
      }

      apply() {
        /* Not laid out (a hidden department, a closed tab): wait for the
           observer to report a width. */
        if (!this.widths || this.avail <= 0) return;

        const { widths, gap, avail, moreWidth } = this;
        let used = 0;
        let count = 0;
        for (const w of widths) {
          const next = used + (count ? gap : 0) + w;
          if (next > avail + 0.5) break;
          used = next;
          count += 1;
        }

        const truncated = this.dataset.truncated === 'true' || count < widths.length;
        if (truncated) {
          while (count > 1 && used + gap + moreWidth > avail + 0.5) {
            count -= 1;
            used -= widths[count] + (count ? gap : 0);
          }
        }

        this.items.forEach((item, i) => {
          const hide = i >= count;
          if (item.hidden !== hide) item.hidden = hide;
        });
        if (this.more && this.more.hidden !== !truncated) this.more.hidden = !truncated;
      }
    }

    customElements.define('card-sizes', CardSizes);
  })();
  } catch(e) { console.error(e); }
})();

})();
